import styled, { keyframes } from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 800px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;

  > div {
    flex: 1;
    min-width: 0;
    margin-right: 1rem;
  }
`;

export const DeviceName = styled.h2`
  margin: 0;
  font-size: 1.4em;
  font-weight: 600;
  color: #2c3e50;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DeviceClient = styled.p`
  margin: 0.25rem 0 0 0;
  color: #6c757d;
  font-size: 0.9em;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  color: #6c757d;
  transition: color 0.2s ease;

  &:hover {
    color: #dc3545;
  }
`;

export const TabContainer = styled.div`
  display: flex;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
`;

export const TabButton = styled.button<{ $isActive: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  border: none;
  background: ${props => props.$isActive ? 'white' : 'transparent'};
  color: ${props => props.$isActive ? '#0C5C75' : '#6c757d'};
  font-weight: ${props => props.$isActive ? '600' : '400'};
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid ${props => props.$isActive ? '#0C5C75' : 'transparent'};

  &:hover {
    color: #0C5C75;
    background: ${props => props.$isActive ? 'white' : '#f1f3f4'};
  }
`;

export const TabContent = styled.div`
  padding: 2rem;
  height: 60vh;
  min-height: 400px;
  max-height: 60vh;
  overflow-y: auto;
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #6c757d;
`;

export const LoadingSpinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid #e3f2fd;
  border-top: 3px solid #0C5C75;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 1rem;
`;

export const StatusTab = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SubTabContainer = styled.div`
  display: flex;
  gap: 0;
  margin-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
`;

export const SubTabButton = styled.button<{ $isActive: boolean }>`
  padding: 0.75rem 1.5rem;
  border: none;
  background: ${props => props.$isActive ? 'white' : 'transparent'};
  color: ${props => props.$isActive ? '#0C5C75' : '#6c757d'};
  font-weight: ${props => props.$isActive ? '600' : '400'};
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 3px solid ${props => props.$isActive ? '#0C5C75' : 'transparent'};
  font-size: 0.95em;

  &:hover {
    color: #0C5C75;
    background: ${props => props.$isActive ? 'white' : '#f8f9fa'};
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  gap: 1rem;
`;

export const MacAddressDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
`;

export const MacAddressLabel = styled.span`
  font-size: 0.85em;
  font-weight: 600;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const MacAddressValue = styled.span`
  font-size: 0.85em;
  color: #2c3e50;
  font-family: 'Monaco', 'Menlo', monospace;
  font-weight: 500;
`;

export const ToggleLabel = styled.span`
  font-size: 0.9em;
  font-weight: 500;
  color: #495057;
`;

export const ToggleWrapper = styled.div`
  display: flex;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  overflow: hidden;
`;

export const ToggleButton = styled.button<{ $isActive: boolean }>`
  padding: 0.5rem 1rem;
  border: none;
  background: ${props => props.$isActive ? '#0C5C75' : 'transparent'};
  color: ${props => props.$isActive ? 'white' : '#6c757d'};
  font-size: 0.85em;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 60px;

  &:hover {
    background: ${props => props.$isActive ? '#0a4f63' : '#e9ecef'};
    color: ${props => props.$isActive ? 'white' : '#495057'};
  }

  &:first-child {
    border-right: 1px solid #e9ecef;
  }
`;

export const JsonContainer = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  height: calc(100% - 60px);
  overflow-y: auto;
  flex: 1;
`;

export const JsonContent = styled.pre`
  margin: 0;
  padding: 1.5rem;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.85em;
  line-height: 1.4;
  color: #2c3e50;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const VisualContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow-y: auto;
`;

export const StatusGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex: 1;
`;

export const StatusCard = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  text-align: center;
  border: 1px solid #e9ecef;
`;

export const StatusLabel = styled.div`
  font-size: 0.8em;
  color: #6c757d;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const StatusValue = styled.div<{ $batteryColor?: string }>`
  font-size: 1.2em;
  font-weight: 600;
  color: ${props => props.$batteryColor || '#2c3e50'};
`;

export const LastUpdate = styled.div`
  text-align: center;
  font-size: 0.9em;
  color: #6c757d;
  font-style: italic;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
`;

export const InstallationTab = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const InfoSection = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
  flex: 1;
  overflow-y: auto;
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e9ecef;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }
`;

export const InfoLabel = styled.div`
  font-weight: 600;
  color: #495057;
  min-width: 140px;
`;

export const InfoValue = styled.div`
  color: #2c3e50;
  text-align: right;

  @media (max-width: 600px) {
    text-align: left;
  }
`;

export const AlarmsTab = styled.div``;

export const AlarmSection = styled.div`
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const AlarmSectionTitle = styled.h3`
  margin: 0 0 1rem 0;
  font-size: 1.1em;
  font-weight: 600;
  color: #2c3e50;
`;

export const AlarmItem = styled.div<{ $type: string; $resolved?: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 0.75rem;
  border-left: 4px solid ${props => {
    switch (props.$type) {
      case 'critical': return '#dc3545';
      case 'warning': return '#ffc107';
      default: return '#17a2b8';
    }
  }};
  background: ${props => props.$resolved ? '#f8f9fa' : 'white'};
  opacity: ${props => props.$resolved ? 0.7 : 1};
  border: 1px solid ${props => props.$resolved ? '#e9ecef' : '#dee2e6'};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const AlarmIcon = styled.div`
  font-size: 1.2em;
  margin-top: 0.1rem;
`;

export const AlarmContent = styled.div`
  flex: 1;
`;

export const AlarmMessage = styled.div`
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 0.25rem;
`;

export const AlarmTime = styled.div`
  font-size: 0.85em;
  color: #6c757d;

  span {
    margin-left: 0.5rem;
  }
`;

export const NoAlarms = styled.div`
  text-align: center;
  color: #6c757d;
  font-style: italic;
  padding: 2rem;
`;

export const SensorSection = styled.div`
  margin-top: 1.5rem;
`;

export const SensorTitle = styled.h4`
  margin: 0 0 1rem 0;
  font-size: 1em;
  font-weight: 600;
  color: #2c3e50;
`;

export const SensorGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
`;

export const SensorCard = styled.div`
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const SensorName = styled.div`
  font-weight: 500;
  color: #2c3e50;
  font-size: 0.95em;
`;

export const SensorStatus = styled.div<{ $isActive: boolean }>`
  font-size: 0.85em;
  font-weight: 600;
  color: ${props => props.$isActive ? '#28a745' : '#6c757d'};
  background: ${props => props.$isActive ? '#d4edda' : '#e9ecef'};
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  text-align: center;
`;

export const MapsLink = styled.a`
  color: #0C5C75;
  text-decoration: none;
  font-weight: 500;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  cursor: pointer;
  
  &:hover {
    color: white;
    background: #0C5C75;
    text-decoration: underline;
  }
  
  &:active {
    opacity: 0.9;
  }
`;